import type { MenuConfig } from '~typings/menu'

import permisosLogisticaPg, { RESOURCE_LOGISTICA_PG } from '@/auth/permissions/modules/logisticaPg'
import {
    ROUTE_ALCANCE_HIELO,
    ROUTE_ALCANCE_VARIOS,
    ROUTE_APROBACION_APERTURA_CONCILIACION,
    ROUTE_CIERRE_MASIVO_CONCILIACION,
    ROUTE_CONCILIACION_ALCANCES,
    ROUTE_CONCILIACION_GUIAS,
    ROUTE_CONCILIACION_GUIAS_HIELO,
    ROUTE_CREAR_CUSTODIO,
    ROUTE_CUSTODIO_GUIA_MOVILIZACION,
    ROUTE_GESTION_ALCANCE_HIELO,
    ROUTE_GESTION_CONCILIACION,
    ROUTE_GESTION_CUSTODIO,
    ROUTE_GESTION_GUIA_MOVILIZACION,
    ROUTE_GUIA_MOVILIZACION,
} from '@/router/routes/logistica-pg/nombres/transacciones'

const { transacciones } = permisosLogisticaPg

export default [
    {
        title: 'logistica_pg.subopciones.custodio',
        resource: RESOURCE_LOGISTICA_PG,
        action: transacciones.custodio._perm,
        children: [
            {
                title: 'logistica_pg.enums.custodio.crear_custodio',
                action: transacciones.custodio.crearCustodio,
                resource: RESOURCE_LOGISTICA_PG,
                route: ROUTE_CREAR_CUSTODIO,
            },
            {
                title: 'logistica_pg.enums.custodio.gestion_custodio',
                action: transacciones.custodio.gestionCustodio,
                resource: RESOURCE_LOGISTICA_PG,
                route: ROUTE_GESTION_CUSTODIO,
            },
            {
                title: 'logistica_pg.enums.custodio.custodio_guia_movilizacion',
                action: transacciones.custodio.custodioGuiaMovilizacion,
                resource: RESOURCE_LOGISTICA_PG,
                route: ROUTE_CUSTODIO_GUIA_MOVILIZACION,
            },
        ],
    },
    {
        title: 'logistica_pg.subopciones.gestion_guia_movilizacion',
        action: transacciones.gestionGuiaMovilizacion,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_GESTION_GUIA_MOVILIZACION,
    },
    {
        title: 'logistica_pg.subopciones.guia_movilizacion',
        action: transacciones.guiaMovilizacion,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_GUIA_MOVILIZACION,
    },
    {
        title: 'logistica_pg.subopciones.gestion_alcance_hielo',
        action: transacciones.gestionAlcanceHielo,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_GESTION_ALCANCE_HIELO,
    },
    {
        title: 'logistica_pg.subopciones.alcance_hielo',
        action: transacciones.alcanceHielo,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_ALCANCE_HIELO,
    },
    {
        title: 'logistica_pg.subopciones.alcance_varios',
        action: transacciones.alcanceVarios,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_ALCANCE_VARIOS,
    },
    {
        title: 'logistica_pg.subopciones.conciliacion_guias',
        action: transacciones.conciliacionGuias,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_CONCILIACION_GUIAS,
    },
    {
        title: 'logistica_pg.subopciones.conciliacion_guias_hielo',
        action: transacciones.conciliacionGuiasHielo,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_CONCILIACION_GUIAS_HIELO,
    },
    {
        title: 'logistica_pg.subopciones.conciliacion_alcances',
        action: transacciones.conciliacionAlcances,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_CONCILIACION_ALCANCES,
    },
    {
        title: 'logistica_pg.subopciones.cierre_masivo_conciliacion',
        action: transacciones.cierreMasivoConciliacion,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_CIERRE_MASIVO_CONCILIACION,
    },
    {
        title: 'logistica_pg.subopciones.aprobacion_apertura_conciliacion',
        action: transacciones.aprobacionAperturaConciliacion,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_APROBACION_APERTURA_CONCILIACION,
    },
    {
        title: 'logistica_pg.subopciones.gestion_conciliacion',
        action: transacciones.gestionConciliacion,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_GESTION_CONCILIACION,
    },
] as MenuConfig[]
